module.exports = __webpack_public_path__ + "static/media/pp-PatientsLaptop.383d7c1d.png";